import { __rest } from "tslib";
import React from 'react';
import VisuallyHidden from '../visually-hidden/visually-hidden';
import { background, thumb, switchStyles } from './switch.css';
import { shadowStyles, visuallyHiddenStyles } from '~/theme/utils.css';
import { withDefaults } from '~/hocs';
import { useControlledValue } from '~/hooks';
import { executeCallbacks, cn } from '~/utils';
const SWITCH_NAME = 'vulcanui-switch';
const Switch = React.forwardRef((props, ref) => {
    const { defaultChecked = false, disabled = false, className, color, onClick, shadow = false, bordered = false, onCheckedChange, checked, required } = props, restProps = __rest(props, ["defaultChecked", "disabled", "className", "color", "onClick", "shadow", "bordered", "onCheckedChange", "checked", "required"]);
    const [localChecked, setLocalChecked] = useControlledValue({
        defaultProp: defaultChecked,
        prop: checked,
        onChange: onCheckedChange
    });
    const changeHandler = () => {
        if (!disabled)
            setLocalChecked(!localChecked);
    };
    return (React.createElement("button", { "aria-disabled": disabled, "aria-checked": localChecked, "aria-required": required, "data-state": getState(localChecked), value: localChecked ? 'on' : 'off', role: "switch", onClick: executeCallbacks(onClick, changeHandler), disabled: disabled, type: "button", className: cn(SWITCH_NAME, className, switchStyles({ bordered, colors: color, disabled, state: getState(localChecked) }), { [shadowStyles.md]: shadow && !disabled && localChecked }) },
        React.createElement(VisuallyHidden, { as: "span" }, localChecked ? 'on' : 'off'),
        React.createElement("input", Object.assign({ "aria-disabled": disabled, "aria-hidden": true, checked: localChecked, className: cn(`${SWITCH_NAME}-input`, visuallyHiddenStyles), defaultChecked: defaultChecked, disabled: disabled, hidden: true, ref: ref, type: "checkbox" }, restProps)),
        React.createElement("span", { role: "thumb", "data-state": getState(localChecked), className: cn(`${SWITCH_NAME}-thumb`, thumb({ bordered, state: getState(localChecked) })) }),
        React.createElement("div", { "data-state": getState(localChecked), className: cn(`${SWITCH_NAME}-background`, background({ state: getState(localChecked), disabled })) })));
});
const getState = (checked) => (checked ? 'checked' : 'unchecked');
Switch.displayName = 'Switch';
Switch.toString = () => `.${SWITCH_NAME}`;
const defaultProps = {
    disabled: false,
    defaultChecked: false,
    color: 'default'
};
export default withDefaults(Switch, defaultProps);
//# sourceMappingURL=switch.js.map